import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MarketplaceComponent } from './marketplace/marketplace.component';
import { AsamcoRouterGuard, CustomRouteConfig } from '@asamco/base';
import { LinkEditPageComponent } from './link/link-edit-page/link-edit-page.component';
import { UsermanagementComponent } from './usermanagement/usermanagement.component';
import { FunctionappmanagementComponent } from './functionappmanagement/functionappmanagement.component';
import { IntegrationTesterComponent } from './integration-tester/integration-tester.component';
import { ContactComponent } from './contact/contact.component';
import { FunctionappversioningComponent } from './functionappversioning/functionappversioning.component';
import { AdminLinkOverviewComponent } from './admin-link-overview/admin-link-overview.component';
import { ApplicationLogsOverviewComponent } from './application-logs-overview/application-logs-overview.component';
import { AdminToolingOverviewComponent } from './admin-tooling/admin-tooling-overview/admin-tooling-overview.component';
import { ApplicationEditComponent } from './admin-tooling/tools/application/application-edit/application-edit.component';
import { FunctionAppsComponent } from './function-apps/function-apps.component';
import { DurableFunctionAppManagementComponent } from './durable-function-app-management/durable-function-app-management.component';
import { EulaComponent } from './eula/eula.component';
import { AdminCompanyManagementGridComponent } from './admin-tooling/tools/admin-company-management-grid/admin-company-management-grid.component';
import { AdminCompanyAccessRequestManagementGridComponent } from './admin-tooling/tools/admin-company-access-request-management-grid/admin-company-access-request-management-grid.component';
import { AdminUserCompanyManagementGridComponent } from './admin-tooling/tools/admin-user-company-management-grid/admin-user-company-management-grid.component';
import { AdminUsersManagementGridComponent } from './admin-tooling/tools/admin-users-management-grid/admin-users-management-grid.component';
import { ApplicationsComponent } from './admin-tooling/tools/application/applications/applications.component';
import { LinkJoblogAdminShellComponent } from './link/link-joblog-searcher-admin/link-joblog-admin-shell/link-joblog-admin-shell.component';
import { LinkJoblogPatternsAdminComponent } from './link/link-joblog-searcher-admin/link-joblog-patterns-admin/link-joblog-patterns-admin.component';
import { LinkJoblogSearchAdminComponent } from './link/link-joblog-searcher-admin/link-joblog-search-admin/link-joblog-search-admin.component';
import { LinkJoblogUnmatchedAdmin } from './link/link-joblog-searcher-admin/link-joblog-unmatched-admin/link-joblog-unmatched-admin.component';
import { LinkTransferToolComponent } from './link-transfer-tool/link-transfer-tool.component';

export const routes: CustomRouteConfig = [
	{
		path: 'dashboard',
		component: DashboardComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'marketplace',
		component: MarketplaceComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'companyusermanagement',
		component: UsermanagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'companyusermanagement/:tab',
		component: UsermanagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'functionappmanagement',
		component: FunctionappmanagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'durable-function-app-management',
		component: DurableFunctionAppManagementComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'functionappversioning',
		component: FunctionappversioningComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'function-apps',
		component: FunctionAppsComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'adminlinkoverview',
		component: AdminLinkOverviewComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'admin-tooling-overview',
		component: AdminToolingOverviewComponent,
		canActivate: [AsamcoRouterGuard],
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'company-management' },

			{ path: 'company-management', component: AdminCompanyManagementGridComponent },
			{ path: 'user-company-management', component: AdminUserCompanyManagementGridComponent },
			{ path: 'user-management', component: AdminUsersManagementGridComponent },
			{ path: 'company-access-request-management', component: AdminCompanyAccessRequestManagementGridComponent },
			{ path: 'link-transfer', component: LinkTransferToolComponent },
			{ path: 'applications', component: ApplicationsComponent },
			{ path: 'application-logs', component: ApplicationLogsOverviewComponent },

			{
				path: 'joblog-pattern-matcher',
				component: LinkJoblogAdminShellComponent,
				children: [
					{ path: '', pathMatch: 'full', redirectTo: 'analysis' },
					{ path: 'analysis', component: LinkJoblogSearchAdminComponent },
					{ path: 'patterns', component: LinkJoblogPatternsAdminComponent },
					{ path: 'unmatched', component: LinkJoblogUnmatchedAdmin },
				],
			},
		],
	},
	{
		path: 'link/:id',
		component: LinkEditPageComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'application/:id',
		component: ApplicationEditComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'integrationtester',
		component: IntegrationTesterComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'contact',
		component: ContactComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{
		path: 'eula',
		component: EulaComponent,
		canActivate: [AsamcoRouterGuard],
	},
	{ path: '', redirectTo: 'dashboard', pathMatch: 'full' },
];
